<!-- //
侧边树组件，添加
@auth xuyd
@date 2024-05-01
//-->
<template>
  <el-form ref="refForm" @submit.native.prevent :model="form" :rules="rules" size="small" label-width="100px">
    <el-row class="flow-row">
      <el-form-item prop="parentId" label="父级">
        <TreeSelect v-model="form.parentId"
                    :options="dataList"
                    :normalizer="normalizer"
                    :show-count="false"
                    style="width: 90%"
                    placeholder="请选择父级分组，若不填写则默认为一级分组"
                    @select="handleParentChange"
        ></TreeSelect>
      </el-form-item>
      <el-form-item prop="terminalType" label="分类" v-if="(form.parentId && form.parentId !='0')">
        <SelectorKeyValue
            v-model="form.terminalType"
            :datasource-list="$store.getters.dictType['TERMINAL_SITE_TYPE']"
            :disabled="disabled || editMode"
            label-type="label"
            style="width: 90%;"/>
      </el-form-item>
      <el-form-item prop="terminalCode" label="code">
        <el-input v-model="form.terminalCode"
                  :disabled="disabled || editMode"
                  clearable style="width: 90%"
                  maxlength="64"
                  show-word-limit
                  placeholder="请输入code"/>
      </el-form-item>

      <el-form-item prop="terminalLabel" label="名称">
        <el-input v-model="form.terminalLabel"
                  :disabled="disabled"
                  clearable style="width: 90%"
                  maxlength="255"
                  show-word-limit
                  placeholder="请输入名称"/>
      </el-form-item>
    </el-row>
  </el-form>
</template>

<script>
import TreeSelect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  name: 'CompSideTreeDetail',
  components: {TreeSelect},
  dictTypes: [
    {dictType: 'TERMINAL_SITE_TYPE', dataType: String}, // 多环境站点分类
  ],
  data() {
    return {
      disabled: false,
      parentNode: null,
      mode: 1, // 新增
      form: {
        id: null,
        parentId: null,
        terminalType: null,
        terminalCode: null,
        terminalLabel: null,
        sort: null,
      },
      rules: {
        terminalCode: [{required: true, message: '请输入code', trigger: 'blur'}],
        terminalLabel: [{required: true, message: '请输入名称', trigger: 'blur'}],
        terminalType: [{required: true, message: '请选择分类', trigger: 'change'}],
      }
    }
  },
  props: {
    dataList: {
      type: Array,
      default: () => {
        return []
      }
    },
    options: {
      type: Object,
      default: () => {
        return {
          children: 'children',
          label: 'terminalLabel',
          maxLevel: 0,
        }
      }
    }
  },
  computed: {
    addMode() {
      return this.mode === 1;
    },
    editMode() {
      return this.mode === 2;
    },
  },
  methods: {
    normalizer(data) {
      return {
        id: data.id,
        label: data[this.options.label],
        children: data[this.options.children],
      }
    },

    /**
     * 选择事件 判断父节点是否到达最大层级
     *
     * @param pnode
     */
    handleParentChange(pnode) {
      this.parentNode = pnode;
      console.log("--------handleParentChange------->", pnode);
      if (this.options.maxLevel && this.options.maxLevel >= 0) {
        this.disabled = pnode.level >= this.options.maxLevel - 1;
        if (this.disabled) {
          this.$modal.msgError("已达到最大层级，请重新选择父级");
        }
      }
    },

    /**
     * 打开事件 判断父节点是否到达最大层级
     * @param opts
     */
    handleOpen(opts) {
      console.log("=====handleOpen opts====", opts);
      this.$refs.refForm.clearValidate();
      this.mode = opts.mode;
      let form = {};
      if(this.addMode) {
        form.parentId = opts.data.id;
        form.terminalType = opts.data.terminalType;
        this.form = form;
        if (this.options.maxLevel && this.options.maxLevel >= 0) {
          this.disabled = opts.data.level >= this.options.maxLevel - 1;
          if (this.disabled) {
            this.$modal.msgError("已达到最大层级，请重新选择父级");
          }
        }
      } else if(this.editMode) {
        form = {...opts.data};
        this.form = form;
      }
    },
    handleClose() {
      this.$refs.refForm.clearValidate();
      this.$refs.refForm.resetFields();
    },
    handleConfirm() {
      return new Promise((resolve, reject) => {
        if (this.disabled) {
          this.$modal.msgError("已达到最大层级，请重新选择父级");
          reject();
          return;
        }
        this.$refs.refForm.validate(valid => {
          if (valid) {
            if (!this.$util.isEmpty(this.form.parentId) && this.form.parentId !== '0' && this.form.id === this.form.parentId) {
              this.$modal.msgError(`节点[${this.form.label}]不能移动到自己节点下`);
              reject();
              return;
            }
            resolve(this.form);
          }
        })
      });
    }
  }
}
</script>

<style lang="less" scoped>

</style>